import i18n from '@/i18n'

export const supportMenu = [
  {
    name: 'AGENT',
    title: i18n.tc('support.sidebarMenu.agentContact'),
    submenu: []
  },
  {
    name: 'MAP',
    title: i18n.tc('support.sidebarMenu.posMap'),
    submenu: []
  }
]
